import React from 'react';

const CalendarRowDivider: React.FC<CalendarRowDividerProps> = ({
    gridRow,
    gridColumnStart,
    gridColumnEnd,
    opacity = 1,
    color = '#ccc',
}) => {
    return (
        <div
            className="calendar-row-divider"
            style={{
                gridRow,
                gridColumnStart,
                gridColumnEnd,
                opacity,
                backgroundColor: color,
            }}
        />
    );
};

interface CalendarRowDividerProps {
    gridRow: string;
    gridColumnStart: string;
    gridColumnEnd: string;
    opacity?: number;
    color?: string;
}

export default CalendarRowDivider;
